<template>
  <div>
    <BreadcrumbsWithShareAccordion :breadcrumbs="breadcrumbs" />
    <section class="pt-8 pb-24 md:pt-20 md:pb-32 text-lg">
      <div class="container">
        <div class="mb-24 lg:mb-0 max-w-400">
          <h1 class="lg:block font-light text-2xl md:text-4xl mb-8 md:mb-20">
            Le tue scelte sui Cookie
          </h1>
          <p class="mb-4">
            Accedendo alla presente area, potrai, in qualsiasi momento ed in
            maniera semplice, modificare le scelte compiute in relazione ai
            Cookie installati mediante il Sito.
          </p>
          <p class="mb-4">
            Per confermare le tue scelte sarà necessario cliccare il bottone
            "Conferma" in fondo alla pagina.
          </p>
          <p class="mb-4">
            Al fine di poter esprimere una scelta informata, ti invitiamo a
            consultare la
            <a class="text-blue" target="_blank" href="/informativacookies"
              >Cookie Policy</a
            >
            del Sito
          </p>
          <p class="mb-12">
            Puoi esprimere o negare il consenso per l'installazione di tutti i
            <strong
              >Cookie di profilazione di cui sono titolari le Terze
              Parti</strong
            >
            sotto indicate (<strong
              >cd. Cookie di profilazione di Terza Parte</strong
            >), agendo sui seguenti bottoni:
          </p>
          <RadioWithValidation
            :items="contactTypes"
            :value="cookie"
            name="TipoContatto"
            rules="required"
            field-classes="mb-12"
            @input="cookieModel = $event"
          >
          </RadioWithValidation>
          <span v-if="cookieLabel" v-dompurify-html="cookieLabel"></span>
          <span v-else>Non hai ancora espresso o negato il tuo consenso</span>
          <UcrsTable :items="items" />

          <OButton
            class="w-full md:w-auto"
            variant="primary"
            :disabled="!cookieModel"
            @click.prevent="submitCookie"
          >
            Conferma
          </OButton>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Libs
import { mapGetters } from 'vuex'

// Mixins
import Cookie from '~/mixins/cookie'

// Components
import BreadcrumbsWithShareAccordion from '~/components/BreadcrumbsWithShareAccordion.vue'
import RadioWithValidation from '~/components/RadioWithValidation.vue'
import UcrsTable from '~/components/UcrsTable.vue'

// Static assets
import { CookieAcceptValue, CookieRejectValue } from '~/assets/js/cookie'

export default {
  components: { BreadcrumbsWithShareAccordion, RadioWithValidation, UcrsTable },
  mixins: [Cookie],
  data() {
    return {
      cookieModel: null,
      items: [
        {
          title: 'Google',
          links: [
            'http://www.google.com/intl/it/policies/privacy/',
            'https://support.google.com/adsense/answer/1348695',
          ],
          description:
            'Promozione e vendita di prodotti e servizi "dedicati" della società UniCredit RE Services, basata sugli interessi manifestati attraverso la navigazione Internet.',
        },
      ],
      breadcrumbs: [
        {
          text: this.$store.state.auth.loggedIn ? 'La mia homepage' : 'Home',
          href: '/',
        },
        {
          text: 'Le tue scelte sui Cookie',
        },
      ],
      contactTypes: [
        { label: 'Autorizzo', value: CookieAcceptValue },
        { label: 'Non Autorizzo', value: CookieRejectValue },
      ],
    }
  },
  computed: {
    ...mapGetters({
      cookie: 'cookie/getCookie',
    }),
    cookieLabel() {
      switch (this.cookieModel) {
        case CookieAcceptValue:
          return 'I cookie di profilazione di Terze parti sono correttamente <span class="font-bold">ABILITATI</span>'
        case CookieRejectValue:
          return 'I cookie di profilazione di Terze parti sono correttamente <span class="font-bold">NON ABILITATI</span>'
        default:
          return ''
      }
    },
  },
  methods: {
    submitCookie() {
      const { cookieModel } = this

      this.setCookie(cookieModel)

      this.$tealium.track({
        event_name: 'cookie_policy_accepted',
        cookie_policy_accepted: cookieModel,
      })

      this.$router.back()
    },
  },
}
</script>
